<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		<div class="content">
			<div class="detail-container">
				<div class="outer">
					<div class="cats">
						<!-- <span>当前位置：</span><span>创意图片</span><i class="iconfont icon-jiantou"></i><span>青岛风光</span> -->
					</div>
					<div class="a1">
						<div class="detail-left">
							<div class="img-outer" v-if="videoDetail.direction!=3">
								<video controls autoplay 
								       :poster="videoDetail.thumb" 
								       :alt="videoDetail.title"
								       muted=""
								       style="object-fit:cover;width:100%;height:100%;" 
								       controlslist="nodownload" 
								       :src="videoDetail.video"
								       oncontextmenu="return false"
								       >
									<!-- <track default kind="captions" /> -->
								</video>
							</div>
							<div class="img-outer-vertical" v-if="videoDetail.direction==3">
								<video controls autoplay 
								       :poster="videoDetail.thumb" 
								       :alt="videoDetail.title"
								       muted=""
								       style="object-fit:contain;width:102%;height:102%;" 
								       controlslist="nodownload" 
								       :src="videoDetail.video"
								       oncontextmenu="return false"
								       >
									<!-- <track default kind="captions" /> -->
								</video>

							</div>
						</div>
						<div class="detail-right">							
							<div class="b4">
								<div class="pic-detail">
									<div class="detail-item">
										<span class="title">{{$t('video.text1')}}</span><span class="item-content">{{videoDetail.id}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.title">
										<span class="title">{{$t('video.text2')}}</span><span class="item-content">{{videoDetail.title}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.extension">
										<span class="title">{{$t('video.text3')}}</span><span class="item-content">{{videoDetail.extension}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.duration">
										<span class="title">{{$t('video.text4')}}</span><span class="item-content">{{videoDetail.duration}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.size">
										<span class="title">{{$t('video.text5')}}</span><span class="item-content">{{videoDetail.size}}MB</span>
									</div>
									<div class="detail-item" v-if="videoDetail.content">
										<span class="title">{{$t('video.desc')}}</span><span class="item-content" v-html="videoDetail.content"></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
			

		</div>
		<Footer/>
	</div>
</template>

<script>
	import tale_video from './tale_video_controller';
	export default tale_video;
</script>

<style src="@/assets/css/tale_video.css" scoped></style>